var Spinner = require("components/utility/Spinner");

class CalendlyContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { loading: true };
	}

	componentDidMount() {
		$wr.loadScript("https://assets.calendly.com/assets/external/widget.js", "CalendlyContainer", () => {
			this.setState({ loading: false })
		});
	}

	render() {
		if (this.state.loading) {
			var spinner = <Spinner placeholder={ true } scale={ 1.7 }/>
		}
		return (
			<div className="calendlyContainer">
				{ spinner }
				<div  className="calendly-inline-widget" data-url={ this.props.url } 
					style={{ minWidth: '480px', height: '640px' }}>
				</div>
			</div>
		);
	}
};

CalendlyContainer.propTypes = StrictPropTypes({
	url: PropTypes.string.isRequired
});

module.exports = CalendlyContainer;


// WEBPACK FOOTER //
// ./modules/components/notifications/CalendlyContainer.js